import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import StarIcon from '@material-ui/icons/StarBorder';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';

import { PopupButton, InlineWidget } from "react-calendly";
import Base13Icon from './../../Color just logo - no background.svg';

const useStyles = makeStyles((theme) => ({
  '@global': {
    ul: {
      margin: 0,
      padding: 0,
      listStyle: 'none',
      autoWidth: 'false',
    },
  },
  button: {
    margin: theme.spacing(1),
    justifyContent: 'left',
    justify: 'left',
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  paper: {
    maxWidth: 120,
    // height: 102,
    borderRadius:16,
    margin: 'auto',
    justifyContent: 'center',
  },
  link: {
    margin: theme.spacing(1, 1.5),
    textDecoration: 'none',
    color: 'white',
    underline: 'none',
    hover: {
    "&:hover": {
      color: '#cbd5e1'
      }
    }
  },
  image: {
    flex: 1,
    padding: 2,
    maxWidth: 120,
    // height: 100,
    resizeMode: 'contain'
  },
  signIn: {
    color: "white",
    backgroundColor:"black",
    borderColor:"black",
    flex: 1,
    textTransform: 'none',
    '&:hover': {
      backgroundColor:"#303030",

    },
    },
  logoPadding: {
    flex: 1,
    padding: 2,
    maxWidth: 20,
    resizeMode: 'contain'
  },
  text: {
    margin: theme.spacing(1),
  },
  heroContent: {
    padding: theme.spacing(8, 0, 6),
    //backgroundColor: "#cccccc",
  },
  cardContent: {
    backgroundColor: 'white',
    color: '#0284c7'
  },
}));

export default function SignIn() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      	<Container maxWidth="lg" component="main" className={classes.heroContent}>
        <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{padding:30}}
        >
          <img className={classes.image} src={Base13Icon}/>
        </Box>

          <Typography component="h1" style={{padding:20}} variant="h4" style={{ fontStyle: 'bolded', fontFamily: 'Arial' }} align="center" color="textPrimary" gutterBottom>
            Welcome back to FloSQL
          </Typography>

          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            style={{padding:40}}
            >
                <Box m="auto" className={classes.button} alignItems="center">
                  <Button className={classes.signIn} size="large" href='https://app.flosql.com/signup' variant="contained" startIcon={<Icon className="fab fa-github" style={{ color: 'white'}} />} >Sign in with Github</Button>
                </Box>
              </Box>

      	</Container>
    </React.Fragment>
  );
}